<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Denounced } from "../../../../Model/Denounced";
  import type { Third } from "../../../../Model/Third";
  import DenouncedInfoForm from "../../DenouncedInfoForm.svelte";
  import { denouncedService } from "../../../../services";

  export let denouncedThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, denouncedThird)

  let size = "lg";
  let denounced: Denounced;

  const dispatch = createEventDispatcher();

  async function load(diligenceId, denouncedThird){
    if (diligenceId && denouncedThird) {

      let denounceds: Denounced[] = await denouncedService.findByDiligenceNumber(diligenceId)
      denounced = denounceds.find(c => c.denouncedThirId == denouncedThird.id)

    }
  }

  async function saveDenouncedTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    denounced.denouncedThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      denouncedService.saveDenounced(denounced),
    ])

    dispatch('saveDenounced');
  }


</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <!-- <TabContent>
      <TabPane tabId="Datas" tab="Datos" active> -->
        {#if denounced}
          <DenouncedInfoForm denounced={denounced} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      <!-- </TabPane>
    </TabContent> -->

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveDenouncedTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

